export default __webpack_public_path__ + "static/media/atomic.dd88edd6.jpeg";